import React from "react";
import { colors } from "../../constants/theme";

interface AppShellProps {
  title: string | React.ReactNode;
  tabs: string[];
  tab: number;
  onTab: (i: number) => void;
  children: React.ReactNode;
  actions?: React.ReactNode;
}

export const AppShell: React.FC<AppShellProps> = ({ title, tabs, tab, onTab, children, actions }) => (
  <div style={{ height: "100vh", width: "100vw", display: "flex", flexDirection: "column", background: colors.bg, fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Helvetica" }}>
    <header style={{ display: "flex", alignItems: "center", padding: "10px 16px", background: colors.card, borderBottom: `1px solid ${colors.border}`, boxShadow: "0 2px 4px rgba(0,0,0,0.05)", flexShrink: 0 }}>
      <h1 style={{ margin: 0, fontSize: 18, color: colors.text, fontWeight: 700 }}>{title}</h1>
      <div style={{ flex: 1 }} />
      {actions && <div style={{ marginRight: 8 }}>{actions}</div>}
      <nav style={{ display: "flex", gap: 8 }}>
        {tabs.map((t, i) => (
          <button key={t} onClick={() => onTab(i)} style={{ padding: "6px 12px", borderRadius: 8, border: `1px solid ${i === tab ? colors.accent : colors.border}`, background: i === tab ? colors.accent : colors.card, color: i === tab ? "#fff" : colors.text, cursor: "pointer" }}>{t}</button>
        ))}
      </nav>
    </header>
    <main style={{ flex: 1, padding: 12, minHeight: 0, overflow: "hidden" }}>{children}</main>
  </div>
);

